import * as React from "react";
import { isChrome, isMobile, isIpad, isWeixin } from "@/util";
import styled from "styled-components";
import { APKNAME } from "@/config/const";
const Container = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  background-color: #ffa;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ChromeCheck: React.FC = () => {

  if (isMobile()) {
    return (
      <Container>
        <span>
          Гар утаснаас орох боломжгүй
          {/* <a
            href={`http://49.232.122.245:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓终端下载
          </a> */}
        </span>
      </Container>
    );
  }

  if (isWeixin()) {
    return (
      <Container>
        <span>
          Гар утаснаас орох боломжгүй
          {/* <a
            href={`http://49.232.122.245:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓终端下载,如果是IOS请联系管理员下载
          </a> */}
        </span>
      </Container>
    );
  }

  return isChrome() ? (
    <></>
  ) : (
    <Container>
      <span>
        您当前所用浏览器不支持所有功能，请下载
        <a
          href="https://www.google.cn/intl/zh-CN/chrome/"
          target="_blank"
          rel="noreferrer"
        >
          谷歌浏览器
        </a>
      </span>
    </Container>
  );
};

export default ChromeCheck;
